// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"397a0bed","213":"1a5a85d5","239":"16de10c0","455":"0b1028da","633":"146bd729"}[chunkId] + ".chunk.js";
};